export const ORDER = {
  dropzone: "upload-dropzone",
  fileInput: "file-input",
  fileItem: "uploaded-file-item",
  removeFile: "remove-file-btn",
  specCopies: "spec-copies",
  specPaper: "spec-paper",
  specColor: "spec-color",
  specSided: "spec-sided",
  specStapling: "spec-stapling",
  specBinding: "spec-binding",
  specLamination: "spec-lamination",
  specNotes: "spec-notes",
  costSummary: "cost-summary",
  customerName: "customer-name",
  customerPhone: "customer-phone",
  customerEmail: "customer-email",
  payBtn: "mpesa-pay-button",
  payPhone: "mpesa-phone-input",
  payConfirm: "mpesa-confirm-button",
  proceedToCheckout: "proceed-to-checkout",
  orderTotal: "order-total",
};

export const ADMIN = {
  ordersTable: "admin-orders-table",
  statusSelect: "admin-status-select",
  pricingForm: "admin-pricing-form",
  saveBtn: "admin-save-pricing",
  downloadFile: "admin-download-file",
  statTotal: "stat-total-orders",
  statRevenue: "stat-revenue",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  order: "nav-order",
  track: "nav-track",
  login: "nav-login",
  signup: "nav-signup",
  dashboard: "nav-dashboard",
  admin: "nav-admin",
  logout: "nav-logout",
};

export const TRACK = {
  input: "track-input",
  submit: "track-submit",
  result: "track-result",
};
